export default __webpack_public_path__ + "static/media/engage-full-color.99e6135e.svg";